// @flow
import React from 'react'

require('./styles.scss')

const intro = require('./header.mp4')
const introMobile = require('./header-mobile.mp4')
const introWebM = require('./header.webm')
const introWebMmobile = require('./header-mobile.webm')
const poster = require('./cover.jpg')

export function cover(props: { title: string, subtitle: string }) {
  const isMobile = window.innerWidth < 800
  const isIOS9 = /iPhone OS [6789]_/.test(navigator.userAgent)

  return (
    <div className='cover'>
      {!isIOS9 && (
        <video
          autoPlay
          muted
          playsInline
          preload
          loop
          poster={poster}
          ref={video => {
            if (video) {
              video.setAttribute('playsinline', '')
            }
          }}
        >
          {isMobile ? console.log('MOBILE VIDEO') : console.log('DESK VIDEO')}
          {isMobile && <source src={introWebM} type='video/webm' />}
          {isMobile && <source src={introWebMmobile} type='video/webm' />}
          {!isMobile && <source src={intro} type='video/mp4' />}
          {isMobile && <source src={introMobile} type='video/mp4' />}
        </video>
      )}
      {isIOS9 && <img src={poster} alt='' className='fallback' />}

      <div className='text-wrapper'>
        <div className='ui container'>
          <div className='ui header'>
            <h1>{props.title}</h1>
            <h2>{props.subtitle}</h2>
          </div>
        </div>
      </div>
    </div>
  )
}

export default cover
